// extracted by mini-css-extract-plugin
export default {"closeButton":"DialogCloseButton_closeButton__nKvUu"};